import cookie from 'cookie-utils-js';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { getCreditsList } from '@/api/credits';
import { loadingIcon } from '@/svg';
import { mixins } from '@/mixins';
import Tab from '@/components/Tab/Tab.vue';
import NoMoreData from '@/components/NoMoreData/NoMoreData.vue';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import DataPlaceHolder from '@/components/DataPlaceHolder/DataPlaceHolder.vue';

export default {
  components: {
    Tab,
    AreaLoading,
    NoMoreData,
    DataPlaceHolder
  },
  
  name: 'CreditsDetail',

  mixins: [mixins],

  data() {
    return {
      firstLoading: false,
      dataList: [],
      nomoreData: false,
      listLoading: false,
      page: 1,
      tabActive: 'record',
      tabList: [
        {
          id: 'record',
          name: 'History'
        },

        {
         id: 'expired',
         name: 'Expired'
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'pageBackgroundColor',
      'cardBackgroundColor',
      'hignlightBorderColor',
      'cardBtnBackgroundColor',
      'primaryBtnBackgroundColor',
      'virtualCurrencyUnit'
    ]),
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.firstLoading = true;
      this.dataList = [];
      this.nomoreData = false;
      this.listLoading = false;
      this.page = 1;
      await this.getBillList({
        page: this.page,
        expired: this.tabActive === 'expired' ? 1 : 0
      });
      this.firstLoading = false;
    },

    async getBillList(opts) {
      const { page, expired } = opts;
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      const res = await getCreditsList({
        token,
        appid,
        page,
        expired
      });
      const currentList = this.makeRenderList(res.data.list);

      if (currentList.length < 20) {
        this.nomoreData = true;
      }

      this.dataList = this.dataList.concat(currentList);
    },

    async onScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      
      if (this.listLoading || this.nomoreData || this.firstLoading) {
        return;
      }

      if(scrollTop + clientHeight >= scrollHeight - 200) {
        this.page++;
        this.listLoading = true;
        await this.getBillList({
          page: this.page,
          expired: this.tabActive === 'expired' ? 1 : 0
        });
        this.listLoading = false;
      }
    },

    makeRenderList(dataList) {
      return dataList.map((item) => {
        return {
          bill_id: item.credits_bill_id,
          value: item.value,
          compute_type: item.compute_type,
          taskName: item.bill_name,
          time: this.toLocalTime(item.created_at)
        };
      });
    },

    async onTabChange(opts) {
      const { activeId } = opts;

      if (this.tabActive === activeId) {
        return;
      }

      this.tabActive = activeId;
      this.reset();
      await this.getBillList({
        page: this.page,
        expired: this.tabActive === 'expired' ? 1 : 0
      });
      this.firstLoading = false;
    },

    reset() {
      this.page = 1;
      this.firstLoading = true;
      this.dataList = [];
      this.nomoreData = false;
      this.listLoading = false;
    }
  }
}
